import React, { useState } from 'react';
import './AddMaterialModal.css';

const EditMaterialModal = ({ onClose, onSubmit, materialData }) => {
  const [formData, setFormData] = useState({
    name: materialData?.name || '',
    category: materialData?.category || '',
    rate: materialData?.rate || ''
  });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    onSubmit(materialData._id, formData);
  };

  return (
    <div className="amm-modal-overlay">
      <div className="amm-modal-content">
        <div className="amm-modal-header">
          <h3>Edit Material</h3>
          <button className="amm-close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="amm-modal-body">
          <div className="amm-form-grid-3">
            <div className="amm-form-group">
              <label>Name</label>
              <input 
                type="text" 
                name="name" 
                className="amm-form-control" 
                value={formData.name}
                onChange={handleChange} 
                placeholder="Material Name"
              />
            </div>
            <div className="amm-form-group">
              <label>Category</label>
              <input 
                type="text" 
                name="category" 
                className="amm-form-control" 
                value={formData.category}
                onChange={handleChange} 
                placeholder="e.g. Liquid, Solid"
              />
            </div>
            <div className="amm-form-group">
              <label>Rate</label>
              <input 
                type="number" 
                name="rate" 
                className="amm-form-control" 
                value={formData.rate}
                onChange={handleChange} 
                placeholder="0.00"
              />
            </div>
          </div>
        </div>
        <div className="amm-modal-footer">
          <button className="amm-btn amm-btn-submit" onClick={handleSubmit}>UPDATE</button>
          <button className="amm-btn amm-btn-cancel" onClick={onClose}>CANCEL</button>
        </div>
      </div>
    </div>
  );
};

export default EditMaterialModal;